// components/DownloadPdfButton.tsx
import React, { useRef, useEffect } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import "./pdf-generator.css";
import { STRINGS } from '../../comman/constants';


const DownloadPdfButton = ({ pdfData }) => {
    const contentRef = useRef(null);
    const radius = 50;
    const stroke = 18;
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (84 / 100) * circumference;


    function formatValue(value) {
        // Convert value to a number if it's a string, then apply toFixed(2)
        const numberValue = typeof value === 'string' ? parseFloat(value) : value;
        return !isNaN(numberValue) ? numberValue.toFixed(1) : '0.00';
    }

    function getFormattedDate() {
        const today = new Date();

        const day = today.getDate();
        const year = today.getFullYear();

        // Array of month names
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        const month = months[today.getMonth()]; // Get the month name

        return `${day} ${month} ${year}`;
    }

    const getRangeValue = (percentage) => {

        if (percentage == 0) return 0;

        // Clamp the percentage value between 1 and 100 to handle edge cases
        const clampedPercentage = Math.min(Math.max(percentage, 1), 100);

        // Map the percentage to a range between 1 and 10
        return Math.floor((clampedPercentage - 1) / 10) + 1;
    };

    const CircularProgressBarCSS = ({ percentage, size }) => {
        const canvasRef = useRef(null);

        useEffect(() => {
            const canvas = canvasRef.current;
            if (canvas) {
                // Increase canvas resolution for high DPI displays
                const scale = window.devicePixelRatio || 1;
                canvas.width = size * scale;
                canvas.height = size * scale;
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.scale(scale, scale);

                    const radius = size / 2;
                    const stroke = 18;
                    const normalizedRadius = radius - stroke / 2;
                    const circumference = normalizedRadius * 2 * Math.PI;
                    const strokeDashoffset = circumference - (percentage / 100) * circumference;

                    // Clear the canvas
                    ctx.clearRect(0, 0, size, size);

                    // Set smoother stroke styles
                    ctx.lineCap = 'butt';

                    // Draw background circle
                    ctx.beginPath();
                    ctx.arc(radius, radius, normalizedRadius, 0, 2 * Math.PI);
                    ctx.strokeStyle = '#263238';
                    ctx.lineWidth = stroke;
                    ctx.stroke();

                    // Draw progress circle
                    ctx.beginPath();
                    ctx.arc(radius, radius, normalizedRadius, -Math.PI / 2, (2 * Math.PI * (percentage / 100)) - Math.PI / 2);
                    ctx.strokeStyle = '#FF835B';
                    ctx.lineWidth = stroke;
                    ctx.stroke();

                    // Draw text with clearer font and weight
                    ctx.fillStyle = '#263238';
                    ctx.font = 'bold 24px Arial'; // Increase font weight and size for clarity
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(`${percentage}%`, radius, radius);
                }
            }
        }, [percentage, size]);

        return <canvas ref={canvasRef} width={size} height={size} style={{ width: size, height: size }} />;
    };




    const ProgressIndicators = ({ percentage }) => {
        const totalIcons = 10;
        const filledIcons = Math.ceil((percentage / 100) * totalIcons);
        const emptyIcons = totalIcons - filledIcons;

        return (
            <div style={{ display: "flex", gap: "12px" }}>
                {Array.from({ length: filledIcons }, (_, index) => (
                    <img src={"assets/icons/personIconOrange.svg"} alt={"alt"} />
                ))}
                {Array.from({ length: emptyIcons }, (_, index) => (
                    <img src={"assets/icons/personIconBlack.svg"} alt={"alt"} />))}
            </div>
        );
    };



    const handleDownload = async () => {
        const element = contentRef.current;
        if (!element) {
            console.error('Element not found');
            return;
        }
        try {
            // Capture the HTML element as a canvas
            const canvas = await html2canvas(element);

            const imgData = canvas.toDataURL('image/png');

            // Create a new jsPDF instance with A4 size
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'px',
                format: 'a4',
            });

            // Get the dimensions of the A4 page
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            // Calculate the scale to fit the content into the A4 page while maintaining aspect ratio
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const scale = Math.min(pageWidth / canvasWidth, pageHeight / canvasHeight);

            // Calculate the final dimensions
            const imgWidth = canvasWidth * scale;
            const imgHeight = canvasHeight * scale;

            // Center the image on the page
            const xOffset = (pageWidth - imgWidth) / 2;
            const yOffset = (pageHeight - imgHeight) / 2;

            // Add the image to the PDF
            pdf.addImage(imgData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);

            // Save the PDF
            pdf.save('download.pdf');
        } catch (e) {
            console.error('Error generating PDF:', e);
        }
    };


    return (

        <>
            <div ref={contentRef} id="peintDocument" style={{ width: '210mm', height: '297mm', boxSizing: 'border-box', fontFamily: 'Arial, sans-serif' }}>
                {/* Background Image Section */}
                <div className='bg-img-container'>
                    <div className='top-container'>
                        <img
                            src="assets/icons/myflexaIcon.svg"
                            alt="Icon"
                            style={{ height: "36px", marginTop: "105px" }} />
                        <p className="progress-report">{STRINGS.pdf.progressReport}</p>
                        <p className="formatted-date">{STRINGS.pdf.till} {getFormattedDate()}</p>
                    </div>
                </div>

                {/* Horizontal Line Section */}
                <div className='hz-line' >
                </div>

                {/* <!-- Overall Impact Section --> */}
                <div>
                    <div className='overallimpact-section '>
                        <img
                            src="assets/icons/overAllImpact.svg"
                            alt="Icon"
                            style={{ height: "32px" }} />
                        <h3>{STRINGS.pdf.overallImpact}</h3>
                    </div>
                    <div className='overall-impact-content' >
                        <div className='overall-impact-column'>
                            <div className='overall-impact-row'>
                                {/* Render percentage and long text */}
                                <div className='overall-impact-row-1' >
                                    <div className='percentage-text'>

                                        {Math.ceil(pdfData?.clinicalImprovementPercentage)}%</div>
                                    {/* <span className="text-orange-600 text-3xl"></span> */}
                                </div>
                                <div className='vertical-divider'>
                                </div>
                                <div className='impact-description'>
                                    {/* Render SVG indicators above text */}
                                    <ProgressIndicators percentage={Math.ceil(pdfData?.clinicalImprovementPercentage)} />
                                    <span className='impact-text'>
                                        {STRINGS.pdf.nearly} <span className='bold-text'>{getRangeValue(Math.ceil(pdfData?.clinicalImprovementPercentage))} {STRINGS.pdf.in10}</span> {STRINGS.pdf.patientsReportedImprovement} <span className='small-text'>{STRINGS.pdf.exerciseAdherence}</span>
                                    </span>
                                </div>
                            </div>
                            <div className='overall-impact-row'>
                                {/* Render percentage and long text */}
                                <div className='overall-impact-row-1'>
                                    <div className='percentage-text'>
                                        {Math.ceil(pdfData?.feltHappyPercentage)}%</div> </div>
                                <div className='vertical-divider' > </div>
                                <div className='impact-description'>
                                    {/* Render SVG indicators above text */}
                                    <ProgressIndicators percentage={Math.ceil(pdfData?.feltHappyPercentage)} />
                                    <span className='impact-text'>
                                        {STRINGS.pdf.nearly} <span className='bold-text'>{getRangeValue(Math.ceil(pdfData?.feltHappyPercentage))} {STRINGS.pdf.in10}</span> {STRINGS.pdf.patientsFeltHappy}
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div className='big-vertical-divider' >
                        </div>
                        <div style={{ width: "40%", textAlign: "center" }}>
                            {/* Add SVG above the text */}
                            <img src="assets/icons/standingIcon.svg" alt="Icon" className='standing-svg' />
                            <div className='total-exercise-count' >{pdfData?.totalExercisePerformed}</div>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <p style={{ fontFamily: "Sans-serif", color: "#667480", fontSize: "14px", width: "200px" }}>
                                    {STRINGS.pdf.totalExercises}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!-- Pain Improvement Section --> */}


                <div>
                    <div className="pain-improvement-section">
                        <img
                            src="assets/icons/painImprovement.svg"
                            alt="Icon"
                            style={{ height: "32px", width: "32px" }}

                        />
                        <h3 className='pain-improvement-text'>Pain Improvement</h3>
                    </div>
                    <div className='pain-improvement-container'>
                        <div className="pain-improvement-card">
                            <div className="circular-indicator-container" >
                                <CircularProgressBarCSS percentage={Math.ceil(pdfData?.improvememtRadiatingPainPercentage)} size={122} />
                            </div>
                            <div className="pain-improvement-text-con" >
                                <div className='pain-improvement-des'>
                                    Patients reported improvement in radiating pain
                                </div>
                            </div>
                        </div>
                        <div className="pain-improvement-card" >
                            <div className="circular-indicator-container" >
                                <CircularProgressBarCSS percentage={Math.ceil(pdfData?.avgPainReductionPercentage)} size={122} />
                            </div>
                            <div className="text-container" >
                                <div className='average-pain-text '>
                                    Avg. pain reduction achieved
                                </div>
                                <div className='average-pain-small-text'>
                                    (Avg pain reduced to {formatValue(pdfData?.avgPainReducedToValue)} points from {formatValue(pdfData?.avgPainReducedFromValue)} points in VAS Scale)
                                </div>
                            </div>
                        </div>
                        <div className="pain-improvement-card">
                            <div className="circular-indicator-container">
                                <CircularProgressBarCSS percentage={Math.ceil(pdfData?.painReductionPercentage)} size={122} />
                            </div>
                            <div className='pain-improvement-text-con' >
                                <div className='pain-improvement-des'>
                                    Patients reported significant reduction in pain
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* footer */}
                <footer className='footer-container' >
                    <div>
                        <img
                            src="assets/icons/myflexaIcon.svg"
                            alt="Icon"
                            style={{ height: "16px" }}
                        />
                    </div>
                    <div className='footer-green-line'></div>
                </footer>
            </div>
            <button onClick={handleDownload} className='download-pdf-button'>
                Download Pdf</button>
        </>
    );

};

export default DownloadPdfButton;
